export default __webpack_public_path__ + "static/fabric-kids-53e0aff2e0c8d3ab88a2a4f089222dd7.webp";